import React from "react";
import "./TopNav.scss";
import { Navbar, Nav } from "react-bootstrap";
import logo from "../../../assets/homelogo.svg";
// import { useLocation } from "react-router-dom";

const TopNav = () => {
  // const location = useLocation().pathname;
  return (
    <div className="topnav" bg="light">
      <Navbar
        expand="lg"
        className="d-flex justify-content-between align-items-center"
      >
        <Navbar.Brand href="#home" className="w-25">
          <img
            src={logo}
            style={{ width: "198px", height: "height: 55px" }}
            alt="logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse
          id="basic-navbar-nav"
          className="justify-content-between flex-column flex-lg-row"
        >
          <div className="d-flex w-75 justify-content-center flex-column flex-lg-row">
            <Nav.Link
              href="/"
              className="myLinks"
              // className={location === "/invest" ? "active" : "inactive"}
            >
              Home
            </Nav.Link>
            <Nav.Link href="/compare" className="myLinks">
              Compare
            </Nav.Link>
            <Nav.Link className="myLinks" href="/login">
              Login
            </Nav.Link>
          </div>
          <div className="d-flex w-25 cta flex-column flex-lg-row justify-content-end align-items-start align-items-lg-center">
            <Nav.Link href="/register" className="myBtn">
              GET STARTED
            </Nav.Link>
          </div>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default TopNav;
